var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { Role } from '../../roles/index.js';
/** The roles an Account may register for (#1833); every other role is given by an office. */
export const REGISTRATION_ROLES = [Role.ADMIN, Role.PATIENT, Role.PREVENTION];
/**
 * `GET /registration-intent` (#1833): what the Account registered for, read by
 * the app when `/auth/offices` is empty. `ADMIN` goes straight into „Praxis
 * eröffnen“, `PATIENT` to the join page of its registration link (#1834).
 * `null` when the Account has none: it never registered through the form, or
 * its first step already consumed it.
 */
export class RegistrationIntentDto {
    role;
    /**
     * The token of the registration link a `PATIENT` registered through; `null`
     * when the link is gone (its location was deleted), and for every other role.
     */
    registrationLinkToken;
}
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RegistrationIntentDto.prototype, "role", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], RegistrationIntentDto.prototype, "registrationLinkToken", void 0);
//# sourceMappingURL=registration-intent.dto.js.map